export const getInventory = state => state.inventory
export const getProduct = productId => state => state.inventory[productId]
